/* NUOMA 3.1 — Fiche produit : pastilles de coloris, barre d'achat mobile, dimensions, zoom.
   Les pastilles pilotent la liste d'origine [data-variant-select] : prix, galerie par SKU,
   disponibilité et URL restent gérés par theme.js, comme avant. */
(() => {
  'use strict';

  /* ---------- Pastilles / boutons de variantes ---------- */
  function syncInputs(section) {
    const select = section.querySelector('[data-variant-select]');
    const option = select?.selectedOptions[0];
    if (!option) return;
    const values = (option.dataset.options || '').split('||');
    section.querySelectorAll('.nuoma-opt').forEach(fieldset => {
      const index = Number(fieldset.dataset.optionIndex);
      const label = fieldset.querySelector('[data-nuoma-option-value]');
      if (label) label.textContent = values[index] || '';
      fieldset.querySelectorAll('.nuoma-opt__input').forEach(input => {
        input.checked = input.value === values[index];
        const candidate = values.slice();
        candidate[index] = input.value;
        const match = [...select.options].find(o => o.dataset.options === candidate.join('||'));
        const visual = section.querySelector(`label[for="${CSS.escape(input.id)}"]`);
        if (visual) {
          visual.classList.toggle('is-unavailable', !match || match.dataset.available !== 'true');
          visual.classList.toggle('is-missing', !match);
        }
      });
    });
    // Barre d'achat mobile
    const variant = section.querySelector('[data-nuoma-sticky-variant]');
    if (variant) variant.textContent = option.dataset.title ? option.dataset.title + ' · ' : '';
    const price = section.querySelector('[data-nuoma-sticky-price]');
    if (price) price.textContent = option.dataset.price;
    const btn = section.querySelector('[data-nuoma-sticky-btn]');
    if (btn) btn.disabled = option.dataset.available !== 'true';
    const img = section.querySelector('.nuoma-sticky-atc__thumb img');
    if (img && option.dataset.image) { img.src = option.dataset.image; img.removeAttribute('srcset'); }
  }

  document.addEventListener('change', event => {
    const target = event.target;
    if (target.matches('[data-variant-select]')) {
      const section = target.closest('[data-product-section]');
      if (section) syncInputs(section);
      return;
    }
    if (!target.matches('.nuoma-opt__input')) return;
    const section = target.closest('[data-product-section]');
    const select = section?.querySelector('[data-variant-select]');
    if (!select) return;
    const chosen = [...section.querySelectorAll('.nuoma-opt')].map(f => f.querySelector('.nuoma-opt__input:checked')?.value ?? '');
    let match = [...select.options].find(o => o.dataset.options === chosen.join('||'));
    if (!match) {
      const index = Number(target.closest('.nuoma-opt').dataset.optionIndex);
      const candidates = [...select.options].filter(o => (o.dataset.options || '').split('||')[index] === target.value);
      match = candidates.find(o => o.dataset.available === 'true') || candidates[0];
    }
    if (match && select.value !== match.value) {
      select.value = match.value;
      select.dispatchEvent(new Event('change', {bubbles: true}));
    } else {
      syncInputs(section);
    }
    const gallery = section.querySelector('.product-gallery');
    if (gallery && document.documentElement.classList.contains('n-anim')) {
      gallery.classList.remove('is-switching');
      void gallery.offsetWidth;
      gallery.classList.add('is-switching');
    }
  });

  /* ---------- Barre d'achat fixe (mobile) ---------- */
  function initSticky(section) {
    const bar = section.querySelector('[data-nuoma-sticky-atc]');
    const add = section.querySelector('.product-purchase [type=submit]');
    if (!bar || !add || !('IntersectionObserver' in window)) return;
    const footer = document.querySelector('.footer');
    let addVisible = true;
    let footerVisible = false;
    // Masquée dès qu'un ajout est confirmé et tant que le panier ou le menu est ouvert.
    let suppressed = false;
    document.addEventListener('nuoma:cart:added', () => { suppressed = true; setTimeout(update, 700); });
    document.addEventListener('nuoma:drawer:open', () => { suppressed = true; update(); });
    document.addEventListener('nuoma:drawer:closed', () => { suppressed = false; update(); });
    const update = () => {
      const show = !suppressed && !addVisible && !footerVisible && matchMedia('(max-width: 989px)').matches;
      if (show) bar.hidden = false;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', String(!show));
      bar.querySelector('button')?.setAttribute('tabindex', show ? '0' : '-1');
    };
    new IntersectionObserver(([entry]) => { addVisible = entry.isIntersecting || entry.boundingClientRect.top > innerHeight; update(); }).observe(add);
    if (footer) new IntersectionObserver(([entry]) => { footerVisible = entry.isIntersecting; update(); }).observe(footer);
  }

  /* ---------- Dimensions : schéma à l'échelle + vérification de passage ---------- */
  function toCm(raw) {
    if (raw == null || raw === '') return null;
    const m = String(raw).replace(',', '.').match(/(-?\d+(?:\.\d+)?)\s*(mm|cm|m)?\b/i);
    if (!m) return null;
    const v = parseFloat(m[1]);
    const unit = (m[2] || 'cm').toLowerCase();
    const cm = unit === 'mm' ? v / 10 : unit === 'm' ? v * 100 : v;
    return cm > 0 && cm < 1000 ? Math.round(cm * 10) / 10 : null;
  }
  function parseText(text) {
    if (!text) return null;
    const clean = text.replace(/\s+/g, ' ').replace(/(\d),(\d)/g, '$1.$2');
    const grab = re => { const m = clean.match(re); return m ? toCm(m[1] + (m[2] || '')) : null; };
    const w = grab(/(?:largeur|\bL)\s*[:=.]?\s*(\d+(?:\.\d+)?)\s*(mm|cm|m)?/i);
    const d = grab(/(?:profondeur|\bP)\s*[:=.]?\s*(\d+(?:\.\d+)?)\s*(mm|cm|m)?/i);
    const h = grab(/(?:hauteur|\bH)\s*[:=.]?\s*(\d+(?:\.\d+)?)\s*(mm|cm|m)?/i);
    if (w && d && h) return {w, d, h};
    const t = clean.match(/(\d+(?:\.\d+)?)\s*[x×*]\s*(\d+(?:\.\d+)?)\s*[x×*]\s*(\d+(?:\.\d+)?)\s*(mm|cm|m)?/i);
    if (t) { const u = t[4] || 'cm'; return {w: toCm(t[1] + u), d: toCm(t[2] + u), h: toCm(t[3] + u)}; }
    return null;
  }
  const fmt = n => (Number.isInteger(n) ? String(n) : n.toFixed(1).replace('.', ','));
  function drawBox(svg, {w, d, h}) {
    const W = 320, H = 220, pad = 34;
    const totalW = w + d * 0.39, totalH = h + d * 0.225;
    const s = Math.min((W - pad * 2) / totalW, (H - pad * 2) / totalH);
    const fw = w * s, fh = h * s, dx = d * 0.39 * s, dy = d * 0.225 * s;
    const x0 = (W - (fw + dx)) / 2, y0 = (H - (fh + dy)) / 2 + dy;
    const p = (x, y) => `${x.toFixed(1)},${y.toFixed(1)}`;
    svg.innerHTML = `
      <polygon class="nuoma-dims__top" points="${p(x0, y0)} ${p(x0 + dx, y0 - dy)} ${p(x0 + fw + dx, y0 - dy)} ${p(x0 + fw, y0)}"/>
      <polygon class="nuoma-dims__side" points="${p(x0 + fw, y0)} ${p(x0 + fw + dx, y0 - dy)} ${p(x0 + fw + dx, y0 - dy + fh)} ${p(x0 + fw, y0 + fh)}"/>
      <rect class="nuoma-dims__front" x="${x0.toFixed(1)}" y="${y0.toFixed(1)}" width="${fw.toFixed(1)}" height="${fh.toFixed(1)}" rx="2"/>
      <g class="nuoma-dims__lines">
        <path d="M${p(x0, y0 + fh + 12)}H${(x0 + fw).toFixed(1)}M${p(x0, y0 + fh + 7)}v10M${p(x0 + fw, y0 + fh + 7)}v10"/>
        <path d="M${p(x0 - 12, y0)}V${(y0 + fh).toFixed(1)}M${p(x0 - 17, y0)}h10M${p(x0 - 17, y0 + fh)}h10"/>
        <path d="M${p(x0 + fw + 10, y0 + fh + 6)}L${p(x0 + fw + dx + 10, y0 + fh - dy + 6)}"/>
      </g>
      <text x="${(x0 + fw / 2).toFixed(1)}" y="${(y0 + fh + 28).toFixed(1)}" text-anchor="middle">L ${fmt(w)}</text>
      <text x="${(x0 - 18).toFixed(1)}" y="${(y0 + fh / 2 + 4).toFixed(1)}" text-anchor="end">H ${fmt(h)}</text>
      <text x="${(x0 + fw + dx / 2 + 16).toFixed(1)}" y="${(y0 + fh - dy / 2 + 18).toFixed(1)}">P ${fmt(d)}</text>`;
  }
  function initDims(box) {
    if (box.dataset.ready) return;
    box.dataset.ready = 'true';
    const w = toCm(box.dataset.w), d = toCm(box.dataset.d), h = toCm(box.dataset.h);
    const dims = (w && d && h) ? {w, d, h} : parseText(box.querySelector('[data-nuoma-dims-text]')?.innerHTML || '');
    if (!dims || !dims.w || !dims.d || !dims.h) { box.hidden = true; return; }
    box.hidden = false;
    drawBox(box.querySelector('[data-nuoma-dims-svg]'), dims);
    box.querySelector('[data-nuoma-dims-summary]').textContent = `${fmt(dims.w)} × ${fmt(dims.d)} × ${fmt(dims.h)} cm`;
    box.querySelector('[data-nuoma-dims-legend]').textContent = `Largeur ${fmt(dims.w)} cm · Profondeur ${fmt(dims.d)} cm · Hauteur ${fmt(dims.h)} cm`;
    const input = box.querySelector('[data-nuoma-door]');
    const result = box.querySelector('[data-nuoma-door-result]');
    const check = () => {
      const door = toCm(input.value);
      if (!door) { result.dataset.state = 'error'; result.textContent = 'Indiquez la largeur de passage en centimètres.'; return; }
      const narrow = Math.min(dims.w, dims.d, dims.h);
      const margin = Math.round((door - narrow) * 10) / 10;
      if (margin >= 5) { result.dataset.state = 'ok'; result.textContent = `Bonne nouvelle : le côté le plus étroit (${fmt(narrow)} cm) passe dans ${fmt(door)} cm, avec ${fmt(margin)} cm de marge. Pensez aussi aux angles des couloirs.`; }
      else if (margin >= 0) { result.dataset.state = 'tight'; result.textContent = `C’est juste : ${fmt(margin)} cm de marge sur le côté le plus étroit (${fmt(narrow)} cm). Retirer les pieds ou les portes peut aider. Une question ? Écrivez-nous avant de commander.`; }
      else { result.dataset.state = 'error'; result.textContent = `Le côté le plus étroit (${fmt(narrow)} cm) dépasse ${fmt(door)} cm. Contactez-nous : nous vous dirons si le meuble se démonte.`; }
    };
    box.querySelector('[data-nuoma-door-check]')?.addEventListener('click', check);
    input?.addEventListener('keydown', e => { if (e.key === 'Enter') { e.preventDefault(); check(); } });
  }

  /* ---------- Visionneuse : zoom au clic, centré sur le point visé ---------- */
  function place(img, x, y) {
    const r = img.getBoundingClientRect();
    img.style.transformOrigin = `${Math.min(100, Math.max(0, (x - r.left) / r.width * 100))}% ${Math.min(100, Math.max(0, (y - r.top) / r.height * 100))}%`;
  }
  document.addEventListener('click', event => {
    const img = event.target.closest('[data-nuoma-zoom-image]');
    if (!img) return;
    const zoomed = img.classList.toggle('is-zoomed');
    if (zoomed) place(img, event.clientX, event.clientY);
  });
  document.addEventListener('pointermove', event => {
    const img = event.target.closest?.('[data-nuoma-zoom-image].is-zoomed');
    if (img) place(img, event.clientX, event.clientY);
  });
  // Changement de photo ou fermeture : retour à la taille normale.
  document.addEventListener('click', event => {
    if (event.target.closest('[data-nuoma-zoom-prev],[data-nuoma-zoom-next],[data-nuoma-zoom-close]')) document.querySelectorAll('[data-nuoma-zoom-image].is-zoomed').forEach(i => i.classList.remove('is-zoomed'));
  }, true);
  document.addEventListener('close', event => {
    if (event.target.matches?.('[data-nuoma-zoom-dialog]')) event.target.querySelector('[data-nuoma-zoom-image]')?.classList.remove('is-zoomed');
  }, true);

  function init(scope = document) {
    scope.querySelectorAll('[data-product-section]').forEach(section => { syncInputs(section); initSticky(section); });
    scope.querySelectorAll('[data-nuoma-dims]').forEach(initDims);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();

/* NUOMA 3.6.6 — Paiement en plusieurs fois (Klarna) : montant recalculé quand la variante change. */
(() => {
  const money = cents => {
    try { return new Intl.NumberFormat(document.documentElement.lang || 'fr-FR', {style: 'currency', currency: window.Shopify?.currency?.active || 'EUR'}).format(cents / 100); }
    catch (_) { return (cents / 100).toFixed(2).replace('.', ',') + ' €'; }
  };
  document.addEventListener('change', event => {
    const select = event.target.closest('[data-variant-select]');
    if (!select) return;
    const section = select.closest('[data-product-section]') || document;
    const block = section.querySelector('[data-split-pay]');
    const cents = Number(select.selectedOptions[0]?.dataset.cents);
    if (!block || !cents) return;
    const count = Number(block.dataset.count) || 3;
    const min = Number(block.dataset.min) || 0;
    const max = Number(block.dataset.max) || 0;
    block.hidden = cents < min || (max > 0 && cents > max);
    const amount = block.querySelector('[data-split-amount]');
    if (amount) amount.textContent = money(Math.floor(cents / count));
  });
})();
